import { render } from "./DiagnosisUpgradeCard.vue?vue&type=template&id=281a1d40&scoped=true"
import script from "./DiagnosisUpgradeCard.vue?vue&type=script&lang=js"
export * from "./DiagnosisUpgradeCard.vue?vue&type=script&lang=js"

import "./DiagnosisUpgradeCard.vue?vue&type=style&index=0&id=281a1d40&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-281a1d40"]])

export default __exports__